import React, { useState } from "react";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import PowerOffIcon from "@mui/icons-material/PowerOff";
import PeopleIcon from "@mui/icons-material/People";
import StorageIcon from "@mui/icons-material/Storage";
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCardInformes";
import AssignmentIcon from "@mui/icons-material/Assignment";

// Componentes personalizados
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Otros imports
import fetchData from "verticales/FetchData";
import ViewClientes from "./Views/viewclientes.js";
import ViewConcurrencia from "./Views/viewconcurrencia.js";
import ViewEC2Resizes from "./Views/viewec2resizes.js";
import ViewEC2Apagados from "./Views/viewec2apagados.js";
import ViewDiscos from "./Views/viewdiscos.js";
import ViewMetricasEc2 from "./Views/viewMetricasEc2.js";
import ViewConsumoEc2 from "./Views/viewConsumoEc2.js";
import ViewEventosClaro from "./Views/vieweventosclaro.js";
import ViewcompaniasActivas from "./Views/viewcompaniasActivas.js";
import GraphReport from "./graphreport.js";

// URL y contexto para las solicitudes
const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

const initialCardData = [
  // {
  //   title: "Eventos Claro",
  //   subtitle: "Informe de envios claro",
  //   action: "correos-enviados-claro-basic",
  //   data: [],
  //   type: "line",
  //   icon: <AnnouncementIcon />,
  // },
  {
    title: "Instancias Resizes",
    subtitle: "Cambio familia Automatico EC2",
    action: "total-resizes",
    data: [],
    type: "table",
    icon: <AutoModeIcon />,
  },
  {
    title: "Instancias Apagados",
    subtitle: "Apagado Automatico EC2 ",
    action: "total-apagados",
    data: [],
    type: "table",
    icon: <PowerOffIcon />,
  },
  {
    title: "Clientes siesa",
    subtitle: "Informe clientes por producto",
    action: "total-clientes",
    data: [],
    type: "table",
    icon: <PeopleIcon />,
  },
  {
    title: "Informe de discos",
    subtitle: "Informe de EBS",
    action: "discos",
    data: [],
    type: "table",
    icon: <StorageIcon />,
  },
  {
    title: "Compañias activas",
    subtitle: "Informe de compañias activas",
    action: "companias-activas",
    data: [],
    type: "table",
    icon: <AssignmentIcon />,
  },
  {
    title: "Métricas Ec2 Performance",
    subtitle: "Informe de Metricas Ec2",
    action: "metricas-ec2",
    data: [],
    type: "table",
    icon: <AssignmentIcon />,
  },
  {
    title: "Métricas Ec2 Consumo",
    subtitle: "Informe de consumos Ec2",
    action: "ec2-metricas-order-cpu-desc",
    data: [],
    type: "table",
    icon: <AssignmentIcon />,
  },
];

const MediaControlCard = () => {
  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
    data: [],
    type: "line",
  });
  const [loading, setLoading] = useState(true);

  const handleOpen = async (card) => {
    setOpen(true);
    setModalContent({ title: card.title, description: card.subtitle, data: [], type: card.type });

    let dtHoy0Horas = new Date();
    dtHoy0Horas.setHours(0);
    dtHoy0Horas.setMinutes(0);
    dtHoy0Horas.setSeconds(0, 0);
    let currentTime = dtHoy0Horas.getTime() / 1000 - 5 * 24 * 60 * 60; // Last 5 days in seconds

    const fetchCardData = async () => {
      try {
        const requestPayload = { action: card.action, timeFilter: currentTime };
        const respData = await fetchData(url, context, requestPayload);

        if (respData && respData.rows) {
          let parsedData = [];

          switch (card.title) {
            case "Eventos Claro":
              parsedData = respData.rows.map((item) => ({
                value: parseInt(item.total, 10),
                name: item.formatted_date,
                event_type: item.event_type,
                event_type_desc: item.event_type_desc,
              }));
              break;
            case "Clientes siesa":
              parsedData = respData.rows.map((item) => ({
                producto: item.producto,
                name_database: item.name_database,
                cuenta: item.cuenta,
                razon_social: item.razon_social,
                fecha_creacion: item.fecha_creacion,
              }));
              break;
            case "Instancias Apagados":
              parsedData = respData.rows.map((item) => ({
                cuenta: item.cuenta,
                instance_id: item.instance_id,
                instance_name: item.instance_name,
                producto: item.producto,
                dias: item.dias,
                hora_apagado: item.hora_apagado,
                hora_encendido: item.hora_encendido,
              }));
              break;
            case "Instancias Resizes":
              parsedData = respData.rows.map((item) => ({
                cuenta: item.cuenta,
                instance_id: item.instance_id,
                instance_name: item.instance_name,
                producto: item.producto,
                dias: item.dias,
                hora_base: item.hora_base,
                hora_resize: item.hora_resize,
              }));
              break;
            case "Concurrencia DB":
              parsedData = respData.rows.map((item) => ({
                nombre_db: item.nombre_db,
                max_concurrencia: item.max_concurrencia,
                fecha: item.fecha,
              }));
              break;
            case "Informe de discos":
              parsedData = respData.rows.map((item) => ({
                instance_id: item.instance_id,
                instance_name: item.instance_name,
                ip_privada: item.ip_privada,
                ip_publica: item.ip_publica,
                cuenta: item.cuenta,
                disk: item.disk,
                total_size: item.total_size,
                used_space: item.used_space,
                free_space: item.free_space,
                free_percent: item.free_percent,
              }));
              break;
            case "Companias activas":
              parsedData = respData.rows.map((item) => ({
                rds_id: item.rds_id,
                name_database: item.name_database,
                nit: item.nit,
                cuenta: item.cuenta,
                fecha_creacion: item.fecha_creacion,
                razon_social: item.razon_social,
                estado_compania: item.estado_compania,
              }));
              break;
            case "Métricas Ec2 Consumo":
              parsedData = respData.rows.map((item) => ({
                cuenta: item.cuenta,
                instance_name: item.instance_name,
                promedio_ram_maximo: item.promedio_ram_maximo,
                total_metricas_analizdas: item.total_metricas_analizdas,
                instance_type: item.instance_type,
              }));
              break;
            default:
              console.error(`No data format found for card: ${card.title}`);
          }

          return parsedData;
        } else {
          console.error(`Invalid data received for ${card.title}`);
          return [];
        }
      } catch (error) {
        console.error(`Error fetching data for ${card.title}:`, error);
        return [];
      }
    };

    const data = await fetchCardData();
    setModalContent({ ...card, data: Array.isArray(data) ? data : [] });
    setLoading(true);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          {initialCardData.map((card, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <MDBox>
                <ComplexStatisticsCard
                  color="dark"
                  icon={card.icon}
                  title={card.title}
                  description={card.subtitle}
                  count={
                    <MDTypography
                      variant="h5"
                      component="a"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpen(card);
                      }}
                      sx={{
                        color: "dark",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      Ver
                    </MDTypography>
                  }
                  percentage={{
                    color: "success",
                    label: card.subtitle,
                  }}
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-end",
        }}
      >
        <Card
          sx={{
            marginTop: "20px",
            width: "100%",
            height: "96%",
            maxHeight: "100vh",
            overflowY: "auto",
            boxShadow: 24,
          }}
        >
          <MDBox px={4} py={2} display="flex" flexDirection="column" justifyContent="space-between">
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h4" color="dark">
                {modalContent.title}
              </MDTypography>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  color: theme.palette.common.dark,
                })}
              >
                <CloseIcon />
              </IconButton>
            </MDBox>

            <MDTypography id="modal-description" variant="h6" color="text" mb={2}>
              {modalContent.description}
            </MDTypography>

            <MDBox
              sx={{
                flex: 4,
                maxHeight: "calc(80vh - 200px)",
              }}
            >
              {modalContent.title === "Clientes siesa" && <ViewClientes data={modalContent.data} />}
              {modalContent.title === "Concurrencia DB" && (
                <ViewConcurrencia data={modalContent.data} />
              )}
              {modalContent.title === "Instancias Resizes" && (
                <ViewEC2Resizes data={modalContent.data} />
              )}
              {modalContent.title === "Instancias Apagados" && (
                <ViewEC2Apagados data={modalContent.data} />
              )}
              {modalContent.title === "Compañias activas" && (
                <ViewcompaniasActivas data={modalContent.data} />
              )}
              {modalContent.title === "Informe de discos" && (
                <ViewDiscos data={modalContent.data} />
              )}
              {modalContent.title === "Métricas Ec2 Performance" && (
                <ViewMetricasEc2 data={modalContent.data} />
              )}
              {modalContent.title === "Métricas Ec2 Consumo" && (
                <ViewConsumoEc2 data={modalContent.data} />
              )}
              {modalContent.title === "Eventos Claro" && <ViewEventosClaro />}
              {![
                "Clientes siesa",
                "Concurrencia DB",
                "Instancias Resizes",
                "Instancias Apagados",
                "Informe de discos",
                "Eventos Claro",
                "Compañias activas",
                "Métricas Ec2 Performance",
              ].includes(modalContent.title) && (
                <GraphReport data={modalContent.data} type={modalContent.type} />
              )}
            </MDBox>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
};

export default MediaControlCard;
